import { IRoute } from '../types';

export const ROUTES: Record<string, IRoute> = {
  HOMEPAGE: {
    id: 'homepage',
    label: 'Homepage',
    path: '/',
  },
  REGULATIONS_OVERVIEW: {
    id: 'regulationsOverview',
    label: 'Regulations Overview',
    path: '/regulations',
  },
  REGULATION_DETAIL: {
    id: 'regulationDetail',
    label: 'Regulation Detail',
    path: '/regulations/:regulationId/:tabId',
  },
  CONTROL_MAPPINGS: {
    id: 'controlMappings',
    label: 'Control Mappings',
    path: '/control-mappings',
  },
};

export const getRegulationDetailPath = (regulationId: string, tabId: string) => `/regulations/${regulationId}/${tabId}`;

export const getPathFromId = (id: string) => {
  const keyFound = Object.keys(ROUTES).find((routeKey: string) => ROUTES[routeKey].id === id);
  if (!keyFound) {
    return undefined;
  }
  return ROUTES[keyFound].path;
};
